import { FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { IPersonalSettingsCarePathServiceConsumerSettingFormSectionProps } from './PersonalSettingsCarePathServiceConsumerSetting';
import { ServiceCode } from '../../../../../common/enums/serviceCode';
import { translateKey } from '../../../../translate';
import { InputTriState } from '../../../elements/common';
import { NumberInput } from '../../../fields/Number';

export function FollowUpMeasurementGgz(props: IPersonalSettingsCarePathServiceConsumerSettingFormSectionProps) {
    if (!props.service.code || ![ServiceCode.GGZOembl, ServiceCode.GGZOint].includes(props.service.code)) {
        return null;
    }

    return (
        <FormSection title={translateKey('addCarePathSettingsHeaders.followUpMeasurementGgz')}>
            <FormGroup label={translateKey('addCarePathSettingsLabelsServiceConsumer.followUpMeasurementGgz')}>
                {props.mode === 'read' ? (
                    <FormParagraph>
                        {props.followUpMeasurementGgz ? translateKey('common.yes') : translateKey('common.no')}
                    </FormParagraph>
                ) : (
                    <InputTriState
                        fieldKey="followUpMeasurementGgz"
                        notNullable
                    />
                )}
            </FormGroup>

            {props.followUpMeasurementGgz && (
                <FormGroup
                    label={translateKey('addCarePathSettingsLabelsServiceConsumer.weeksForFollowUpMeasurementGgz')}
                >
                    {props.mode === 'read' ? (
                        <FormParagraph>
                            {props.weeksForFollowUpMeasurementGgz ? `${props.weeksForFollowUpMeasurementGgz}` : '-'}
                        </FormParagraph>
                    ) : (
                        <NumberInput
                            error={props.errors.get('weeksForFollowUpMeasurementGgz')}
                            fieldKey="weeksForFollowUpMeasurementGgz"
                            placeholder="weken"
                            width="medium"
                        />
                    )}
                </FormGroup>
            )}
        </FormSection>
    );
}
